import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showApiErrorToast } from '@/utils/errors';
import { logout } from '../api/auth.api';

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.clear();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Logout failed');
    },
  });
}
